import React from 'react';
import { Route, Navigate, Routes as Switch } from 'react-router-dom';

import Application from './InternalPages/Application';
import CheckingApplication from './InternalPages/CheckingApplication';
import Congratulations from './InternalPages/Congratulations';
import OfferSuggestion from './InternalPages/OfferSuggestion';
import AutoPayElection from './InternalPages/AutoPayElection';
import CreditOfferConfirmation from './InternalPages/CreditOfferConfirmation';
import CreditAppDoc from './InternalPages/CreditAppDoc';
import WorkflowComplete from './InternalPages/WorkflowComplete';
import SignLoanDocument from './InternalPages/SignLoanDocument';
import Declined from './InternalPages/Declined';
import CreditFreeze from './InternalPages/CreditFreeze';
import Blocked from './InternalPages/Blocked';
import DocusignTimeout from './InternalPages/DocusignTimeout';
import DocusignDeclined from './InternalPages/DocusignDeclined';
import DirectAccess from './InternalPages/DirectAccess';
import GeneralErrorPage from './InternalPages/GeneralErrorPage';
import withIPAddress from './withIPAddress';
import ErrorPage from './InternalPages/ErrorPage';
import Error from './InternalPages/Error';
import IdCheckPersonalInfo from './InternalPages/IdCheckPersonalInfo';
import IdCheckQuestions from './InternalPages/IdCheckQuestions';
import ManualVerification from './InternalPages/ManualVerification';
import BankAccountVerification from './InternalPages/BankAccountVerification';
import ConnectBankAccount from './InternalPages/ConnectBankAccount';
import AppInvitationBumper from './InternalPages/AppInvitationBumper';
import SSNCheck from './InternalPages/SSNCheck';
import Timeout from './InternalPages/Timeout';
import ThankYou from './InternalPages/ThankYou';
import BankStatements from './InternalPages/BankStatements';
import BankVerificationCompleted from './InternalPages/BankVerificationCompleted';
import BankVerificationReview from './InternalPages/BankVerificationReview';
import PickPaymentDate from './InternalPages/PickPaymentDate';
import EsignLoanDocs from './InternalPages/EsignLoanDocs';

// Microbilt
import Microbilt from './InternalPages/Microbilt/Verification';
import MicrobiltWelcome from './InternalPages/Microbilt/Welcome';
import MicrobiltWait from './InternalPages/Microbilt/Wait';
import FSLPending from './InternalPages/Pending';

// Workflow Redirection
import Redirection from './InternalPages/Redirection';

import { parseUrlParams } from 'utils/parseUrlParams';
import { getKeyAction } from '../actions/workflow';
import { store } from '../index';

import 'assets/styles/tailwind.css';

// eslint-disable-next-line react/prop-types
const GuardedRoute = ({ component: Component }) => {
  const params = parseUrlParams(window.location.search);
  if (!params.key && params.applicationId) {
    const queryParams = new URLSearchParams(window.location.search);
    store.dispatch(getKeyAction({
      entityType: 'application',
      entityId: params.applicationId,
      workflowType: 'fsl',
      success: (response) => {
        queryParams.delete('applicationId');
        queryParams.set('key', response.key);
        window.location.href = `${window.location.pathname}?${queryParams.toString()}`;
      },
    }));
    return null;
  } else {
    return <Component />;
  }
};

const routes = [
  {
    name: 'Application',
    pathname: '/fsl/application',
    component: withIPAddress(Application),
    exact: true,
  },
  {
    name: 'Sign Loan Document',
    pathname: '/fsl/:workflowType/step/:stepName',
    component: DirectAccess,
    exact: true,
    wrapper: Route,
  },
  {
    name: 'SSN Check',
    pathname: '/fsl/welcome-back',
    component: SSNCheck,
    exact: true,
  },
  {
    name: 'Credit Offer',
    pathname: '/fsl/offer-suggest',
    component: OfferSuggestion,
    exact: true,
  },
  {
    name: 'Credit Offer',
    pathname: '/fsl/error',
    component: ErrorPage,
    exact: true,
  },
  {
    name: 'Congratulations',
    pathname: '/fsl/congratulations',
    component: Congratulations,
    exact: true,
  },
  {
    name: 'Bank Account Verification',
    pathname: '/fsl/bank-account-verification',
    component: BankAccountVerification,
    exact: true,
  },
  {
    name: 'Connect Bank Account',
    pathname: '/fsl/connect-bank-account',
    component: ConnectBankAccount,
    exact: true,
  },
  {
    name: 'App Invitation',
    pathname: '/fsl/invitation',
    component: AppInvitationBumper,
    exact: true,
  },
  {
    name: 'Auto-Pay Election',
    pathname: '/fsl/autopayelection',
    component: AutoPayElection,
    exact: true,
  },
  {
    name: 'Credit Offer Confirmation',
    pathname: '/fsl/creditofferconfirmation',
    component: CreditOfferConfirmation,
    exact: true,
  },
  {
    name: 'Credit App Docusign',
    pathname: '/fsl/creditappdoc',
    component: CreditAppDoc,
    exact: true,
  },
  {
    name: 'Workflow Complete',
    pathname: '/fsl/docusign/complete',
    component: WorkflowComplete,
    exact: true,
  },
  {
    name: 'Sign Loan Document',
    pathname: '/fsl/signloandocument',
    component: SignLoanDocument,
    exact: true,
  },
  {
    name: 'New E-Sign',
    pathname: '/:workflowtype/contract/sign',
    component: EsignLoanDocs,
    exact: true,
  },
  {
    name: 'Credit Freeze',
    pathname: '/fsl/creditfreeze',
    component: CreditFreeze,
    exact: true,
  },
  {
    name: 'Declined',
    pathname: '/fsl/declined',
    component: Declined,
    exact: true,
  },
  {
    name: 'Blocked',
    pathname: '/fsl/declined2',
    component: Blocked,
    exact: true,
  },
  {
    name: 'Signing document timed out',
    pathname: '/fsl/docusign/timeout',
    component: DocusignTimeout,
    exact: true,
  },
  {
    name: 'Docusign Declined',
    pathname: '/fsl/docusign/declined',
    component: DocusignDeclined,
    exact: true,
  },
  {
    name: 'Docusign Declined',
    pathname: '/fsl/general-error-page',
    component: GeneralErrorPage,
    exact: true,
  },
  {
    name: 'Error Page',
    pathname: '/applications/:workflowtype/error',
    component: Error,
    exact: true,
  },
  {
    name: 'ID Check Personal Information',
    pathname: '/fsl/:workflowtype/identity/confirmation',
    component: IdCheckPersonalInfo,
    exact: true,
  },
  {
    name: 'ID Check Questions',
    pathname: '/fsl/:workflowtype/identity/questions',
    component: IdCheckQuestions,
    exact: true,
  },
  {
    name: 'Microbilt Verification',
    pathname: '/microbilt/verification',
    component: Microbilt,
    exact: true,
  },
  {
    name: 'Microbilt Welcome',
    pathname: '/microbilt/welcome',
    component: MicrobiltWelcome,
    exact: true,
  },
  {
    name: 'Microbilt Wait',
    pathname: '/microbilt/wait',
    component: MicrobiltWait,
    exact: true,
  },
  {
    name: 'Microbilt Pending',
    pathname: '/fsl/pending',
    component: FSLPending,
    exact: true,
  },
  {
    name: 'Manual Verification',
    pathname: '/applications/fsl/identity/manual-verification',
    component: ManualVerification,
    exact: true,
  },
  {
    name: 'Timeout',
    pathname: '/applications/fsl/identity/timeout',
    component: Timeout,
    exact: true,
  },
  {
    name: 'Checking Application',
    pathname: '/applications/:workflowtype/checkin',
    component: CheckingApplication,
    exact: true,
  },
  {
    name: 'Workflow Redirection',
    pathname: '/applications/:workflowtype/redirection',
    component: Redirection,
    exact: true,
  },
  {
    name: 'Pick new payment date',
    pathname: '/:workflowtype/pick-payment-date',
    component: PickPaymentDate,
    exact: true,
  },
  {
    name: 'Bank Statement',
    pathname: '/fsl/bank-statements',
    component: BankStatements,
    exact: true,
  },
  {
    name: 'What\'s Next',
    pathname: '/fsl/thank-you',
    component: ThankYou,
    exact: true,
  },
  {
    name: 'Bank Verification Completed',
    pathname: '/fsl/bank-verification-completed',
    component: BankVerificationCompleted,
    exact: true,
  },
  {
    name: 'Bank Verification Review',
    pathname: '/fsl/bank-statements-review',
    component: BankVerificationReview,
    exact: true,
  },
];

const Routes = () => (
  <Switch>
    {routes.map((route, index) => (
      <Route
        key={index}
        path={route.pathname}
        exact={route.exact || false}
        element={<GuardedRoute component={route.component} />}
      />
    ))}
    <Route path="*" element={<Navigate to="/fsl/application" />} />
  </Switch>
);

export default Routes;
